import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { RequestCustomfieldComponent } from 'src/app/page_component/request-customfield/request-customfield.component';
import { RequestOpeningComponent } from 'src/app/page_component/request-opening/request-opening.component';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { requestInterface } from 'src/app/util/interfaces/request';
import { MspPipesModule } from 'src/app/util/pipes/msp-pipes.module';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestPageExtraOptionsService } from './data/request-page-extra-options.service';
import { RequestPageService } from '../../../service/request-page.service';

@Component({
	selector: 'pcp-request-page-tab-extra-options',
	standalone: true,
	imports: [CommonModule, RequestCustomfieldComponent, MspPipesModule, FontAwesomeModule, RequestOpeningComponent],
	templateUrl: './request-page-tab-extra-options.component.html',
	styleUrl: './request-page-tab-extra-options.component.scss',
})
export class RequestPageTabExtraOptionsComponent implements OnInit {
	private readonly labelsService = inject(LabelsService);
	private readonly notificationService = inject(NotificationService);
	private readonly profileService = inject(ProfileService);
	private readonly requestPageExtraOptionsService = inject(RequestPageExtraOptionsService);
	private readonly requestPageService = inject(RequestPageService);

	icons = {
		faAngleDown: faAngleDown,
	};
	labels: LabelsInterface;

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}

	@Input() requestData: requestInterface;
	@Input() customfields: genericFormInterface[];

	newRequestData: requestInterface;
	newCustomfields: genericFormInterface[];

	duplicateRequestInfo = false;
	duplicateTimeout: NodeJS.Timeout;

	isCustomfieldLoading = false;

	isOpeningRelatedRequest = false;
	relatedRequestOptions = {
		hide: ['classifyButton', 'enduser'],
		hide_service_type: ['2', '5'],
		initial_enduser: null,
		initial_id_enduser: null,
		initial_summary: '',
		initial_related_request_id: '',
	};

	ngOnInit(): void {
		this.relatedRequestOptions.initial_enduser = this.requestData.enduser;
		this.relatedRequestOptions.initial_id_enduser = this.requestData.id_enduser;
		this.relatedRequestOptions.initial_related_request_id = this.requestData.id;
	}

	duplyRequest(htmlReference: HTMLElement): void {
		let isNewCustomfieldFulfilled = true;
		if (this.newCustomfields && this.newCustomfields.length > 0) {
			for (const newCustomfield of this.newCustomfields) {
				if (
					newCustomfield.hidden == false &&
					newCustomfield.required == true &&
					(!newCustomfield.values[0] || newCustomfield.values[0].toString().trim() == '' || newCustomfield.values[0] == '-1')
				) {
					isNewCustomfieldFulfilled = false;
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
					continue;
				}

				// Verificar se o valor excede 255 caracteres
				if (newCustomfield.values[0] && newCustomfield.values[0].toString().length > 255) {
					isNewCustomfieldFulfilled = false;
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_max_caracteres_campo_customizado);
					continue;
				}
			}
		}
		if (isNewCustomfieldFulfilled == true) {
			htmlReference.classList.add('wait');
			this.requestPageExtraOptionsService.duplyRequest(this.newRequestData).subscribe(
				(res: any) => {
					if (this.newCustomfields?.length > 0) {
						this.requestPageService.postCustomfields(this.newCustomfields, res.id).subscribe();
					}
					this.notificationService.setNotificationMessage(`${this.labels.lbl_chamado_clonado_id}'${res.id}'`);
					this.notificationService.setFunctionOnMessage(() => {
						window.open('/request/' + res.id);
					});
					htmlReference.classList.remove('wait');
					this.duplicateRequestInfo = false;
				},
				(error) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_sem_permissao_duplicar_essa_classificacao);
					htmlReference.classList.remove('wait');
					this.duplicateRequestInfo = false;
				}
			);
		}
	}

	setConfirmButton(htmlReference: HTMLElement): void {
		if (this.profileService.userData().usertype.includes('enduser.regular')) {
			if (this.profileService.userData().fullName !== this.requestData.enduser) {
				return this.notificationService.setNotificationMessage(
					this.labels.lbl_apenas_usuario_solicitante_pode_duplicar_proprio_chamado
				);
			} else if (this.requestData.service_type !== 'Service Request') {
				return this.notificationService.setNotificationMessage(this.labels.lbl_apenas_permitido_duplicar_solicitacao_servico);
			}
		}
		if (this.duplicateRequestInfo == true) {
			const actualLabel = htmlReference.innerHTML;
			htmlReference.innerHTML = this.labels.lbl_geral_confirmar;

			htmlReference.classList.add('confirm');
			this.duplicateTimeout = setTimeout(() => {
				htmlReference.innerHTML = actualLabel;
				htmlReference.classList.remove('confirm');
			}, 5000);
		} else {
			this.newRequestData = { ...this.requestData };
			this.isCustomfieldLoading = true;
			this.newCustomfields = { ...this.customfields };
			this.isCustomfieldLoading = false;
			this.duplicateRequestInfo = true;
		}
	}

	closeDuplicateRequest(htmlReference: HTMLElement) {
		this.duplicateRequestInfo = false;
		htmlReference.innerHTML = this.labels.lbl_duplicar_chamado;
		htmlReference.classList.remove('confirm');
		clearTimeout(this.duplicateTimeout);
	}
}
